import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  ProductFlowService,
  ProductFlowConfig,
  LaunchEvent,
} from 'app/infrastructure/services/productFlow.service';
import { RuleService } from 'app/infrastructure/services/reglas.service';
import {
  AlertService,
  GrowlType,
} from 'app/infrastructure/services/alert.service';
import { SxHttpService } from 'app/infrastructure/services/sxHttp.service';
import { CacheService } from 'app/infrastructure/services/cache.service';
import { SxDocumentTypes } from '../sxfdesigner/components/main/completeContext';
import { OpcionCheckeable } from 'app/infrastructure/services/selects.service';
import { flowSources } from 'app/infrastructure/model/interfaces/flowSources.interface';
import { StandardDictionary } from 'app/infrastructure/model/interfaces/standarddictionary.interface';
import { LoaderService } from 'app/infrastructure/services/loader.service';
import { saveAs } from 'file-saver';
import { StandardFileContentModel } from "app/infrastructure/services/azureFileManager.service";
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  selector: 'sx-product-flow-config',
  templateUrl: './productFlowConfig.component.html',
})
export class ProductFlowConfigComponent implements OnInit {
  public searchPage: string;
  public searchInteractionRule: string;

  codSistema: string;
  codNegocio: string;
  codProduct: string;
  codFlow: string;
  documentKind: string;
  standardFlow: boolean;
  standardKey: string = null;
  categories: OpcionCheckeable[];
  standardDictionary: StandardDictionary[];
  selectedCategories: OpcionCheckeable[];

  specificScopeConfig = {
    displayKey: 'descripcion',
    search: true,
    limitTo: 10,
    placeholder: this.sxTranslationService.getResource('SELECT_PHOLDER'),
  };

  preguntarSiDeseaBorrarPage = [];
  preguntarSiDeseaBorrarRule = [];

  isNew = false;

  newPageId: string;
  validId = true;

  flowSources = flowSources;
  sourceValue: number;

  flowConfig: ProductFlowConfig = {
    flowId: -1,
    title: '',
    flowCode: '',
    rules: [
      {
        value: '',
        name: '',
      },
    ],
    pages: [
      {
        value: '',
        name: '',
        pageNumber: 0,
      },
    ],
    interactionRules: [
      {
        value: '',
        name: '',
      },
    ],
    launchEvents: [],
    hasReferences: false,
    categories: [],
    standardDictionaryId: null,
    standardDictionaryName: null,
  };

  constructor(
    private productFlowService: ProductFlowService,
    private ruleService: RuleService,
    private alert: AlertService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private http: SxHttpService,
    private alertService: AlertService,
    private cacheService: CacheService,
    public loader: LoaderService,
    private sxTranslationService: SxTranslationService
  ) {
  }

  ngOnInit() {
    this.aRoute.data.subscribe((data) => {
      this.standardFlow =
        data.standardFlow != undefined ? data.standardFlow : false;
        this.aRoute.params.subscribe((params: Params) => {
          this.codSistema = params['codsistema'];
          this.codNegocio = params['codnegocio'];
          this.codProduct = params['codproducto'];
          this.codFlow = params['codFlow'];
          this.documentKind = params['documentKind'];
          this.flowConfig.standardDictionaryId = params['codstandarddictionary'];
          if (this.codSistema === undefined) {
            this.codSistema = 'null';
          }
          if (this.codNegocio === undefined) {
            this.codNegocio = 'null';
          }
          if (this.codProduct === undefined) {
            this.codProduct = 'null';
          }
          if (this.documentKind === undefined) {
            this.documentKind = SxDocumentTypes.None;
          }
          if (this.codFlow === 'NewFlow') {
            if (Object.keys(params).length > 1) {
              this.isNew = true;
              this.sourceValue = 0;
            }
            if (this.standardFlow) {
              this.productFlowService.getCategories().then((x) => {
                this.categories = x.map(cat=> {return {id: cat.categoryId, descripcion: cat.descripcion, seleccionado: cat.selected} as OpcionCheckeable}) as OpcionCheckeable[];
              });
              this.productFlowService.getStandardDictionary().then((x) => {
                this.standardDictionary = x as StandardDictionary[];
              });
            }
          } else {
            if (this.standardFlow) {
              this.productFlowService
                .getConfiguration(
                  this.codSistema,
                  this.codNegocio,
                  this.codProduct,
                  this.codFlow,
                  this.documentKind,
                  this.standardKey
                )
                .subscribe((x) => {
                  this.flowConfig = x;
                  this.isNew = false;
                });
            } else {
              this.productFlowService
                .getStandardConfiguration(
                  this.codSistema,
                  this.codNegocio,
                  this.codProduct,
                  this.codFlow,
                  this.documentKind,
                  this.standardKey
                )
                .subscribe((x) => {
                  this.flowConfig = x;
                  this.isNew = false;
                });
            }
          }
        });
    });
  }

  flowCodeChanged(event: string) {
    if (event === 'NewFlow') {
      this.alert.showGrowl({
        type: GrowlType.WARNING,
        body: 'INVALID_CODE',
      });
    } else {
      this.flowConfig.flowCode = event;
    }
  }
  //------------------ CATEGORIES --------------------//

  changeCategories(categories: OpcionCheckeable[]) {
      this.selectedCategories = [];
      this.selectedCategories = categories
  }

  onSaveChanges() {
    if (this.flowConfig.flowCode === '') {
      this.alert.showGrowl({
        type: GrowlType.WARNING,
        body: 'INVALID_CODE',
      });
      return;
    }
    let categories:string[];
    if (this.standardFlow == true) {
      this.standardKey = null;
      if(this.selectedCategories.length > 0)
      categories = this.selectedCategories.map(x => x.id);
      console.log(this.selectedCategories);
      this.productFlowService
        .CreateNewStandardFlow(
          this.flowConfig.flowCode,
          this.documentKind,
          categories,
          this.flowConfig.standardDictionaryId
        )
        .then((x) => {
          this.flowConfig = x;
          this.isNew = false;
          this.router.navigate(['../'], { relativeTo: this.aRoute });
        });
    } else {
      this.productFlowService
        .CreateNewFlow(
          this.codSistema,
          this.codNegocio,
          this.codProduct,
          this.flowConfig.flowCode,
          this.documentKind
        )
        .then((x) => {
          this.flowConfig = x;
          this.isNew = false;
          this.router.navigate(['../'], { relativeTo: this.aRoute });
        });
    }
  }

  validateSave() {
    return this.flowConfig.flowCode !== '' && this.flowConfig.title !== '' && this.selectedCategories != null && this.selectedCategories.length > 0 ? true : false;
  }

  eventDisabled(event: LaunchEvent) {
    return event == null || event.label == null || event.label.trim() === '';
  }

  clickEditEvent(event: LaunchEvent) {
    this.productFlowService.UpdateLaunchEvent(event).then((success) => {
      let body = GrowlType.SUCCESS;
      let type = 'LAUNCH_EVENT_UPDATED';

      if (!success) {
        body = GrowlType.DANGER;
        type = 'SOC_FE_0001_ERROR';
      }

      this.alertService.showGrowl({
        type: body,
        body: type,
      });
    });
  }

  // --------------------------------------------------------------------
  // rules
  clickEditRule(ruleCommand: string) {
    this.router.navigate(['.', 'interactionEvent', 'FlowEvent', ruleCommand], {
      relativeTo: this.aRoute,
    });
  }

  clickEditLaunchRule(ruleCommand: string) {
    this.router.navigate(
      ['.', 'interactionEvent', 'LaunchEvent', ruleCommand],
      { relativeTo: this.aRoute }
    );
  }

  clickEditPageRule(codPage: string) {
    this.router.navigate(
      ['interactionEvent', 'PageEvent', 'OnBeginStep', codPage],
      { relativeTo: this.aRoute }
    );
  }

  // --------------------------------------------------------------------
  // pages

  idValidation(event: any) {
    const regex: RegExp = /([!@#$%^&*(),.?":{}|<>\-_\s/\/])/g;
    const isInvalid: boolean = regex.test(event.target.value);
    if (isInvalid) {
      this.validId = false;
      this.alertService.showGrowl({
        type: GrowlType.DANGER,
        body: 'INVALID_PAGE_ID',
      });
    } else {
      this.validId = true;
    }
  }

  onClickNewPage() {
    const pageId = this.newPageId;
    this.newPageId = undefined;
    this.router.navigate(['sxfDesigner', pageId], { relativeTo: this.aRoute });
  }

  clickEditPage(pageId: string) {
    this.router.navigate(['sxfDesigner', pageId], { relativeTo: this.aRoute })
  }

  clickDeletePage(pageId: string) {
    const url = `api/sxpagefdesigner/${this.codSistema}/${this.codNegocio}/${this.codProduct}/${this.codFlow}/${this.documentKind}/${this.standardKey}/${pageId}`;
    this.http
      .delete(url)
      .toPromise()
      .then((_) => {
        this.alertService.showGrowl(
          {
            type: GrowlType.SUCCESS,
            body: 'SUCCESSFUL_DELETE_PAGE_WITH_ID',
          },
          { pageId: pageId }
        );
        this.flowConfig.pages = this.flowConfig.pages.filter(
          (p) => p.value !== pageId
        );
      })
      .catch((response) =>
        this.alertService.showGrowl(
          {
            type: GrowlType.DANGER,
            body: 'SOC_FE_0009_COULD_NOT_DELETE_PAGE_WITH_ID',
          },
          { pageId: pageId }
        )
      );
  }

  // --------------------------------------------------------------------
  // interaction rules
  onClickNewInteractionRule() {
    this.router.navigate(
      ['.', 'interactionEvent', 'InteractionEvent', 'NewRule'],
      { relativeTo: this.aRoute }
    );
  }

  clickEditInteractionRule(ruleCommand: string) {
    this.router.navigate(
      ['.', 'interactionEvent', 'InteractionEvent', ruleCommand],
      { relativeTo: this.aRoute }
    );
  }

  clickDeleteInteractionRule(ruleCommand: string) {
    this.ruleService.delete(ruleCommand).then((x) => {
      this.productFlowService
        .getConfiguration(
          this.codSistema,
          this.codNegocio,
          this.codProduct,
          this.codFlow,
          this.documentKind,
          this.standardKey
        )
        .subscribe((x) => {
          this.flowConfig = x;
          this.isNew = false;
        });

      this.alertService.showGrowl({
        type: GrowlType.SUCCESS,
        body: `INTERACTION_RULE_REMOVED`,
      });
    });
  }

  successfulDelete(response: any): void {
    this.alertService.showGrowl(
      {
        type: GrowlType.SUCCESS,
        body: 'DATA_SAVED_WITH_ID',
      },
      { id: response.data.id }
    );
  }

  preview() {
    this.cacheService.setCurrentFlowId(this.flowConfig.flowId);
    this.router.navigate(['preview'], { relativeTo: this.aRoute });
  }

  goToDynamicStyle() {
    this.router.navigate(['dynamicStyles'], { relativeTo: this.aRoute });
  }

  export() {
    this.productFlowService
      .exportStandard(this.codFlow, this.documentKind, this.standardKey)
      .subscribe((data) => {
        this.convertirYDescargar(data);
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'EXPORTACION_EXITOSA',
        });
      });
  }

  download(content, filename, contentType) {
    const blob = new Blob([content], { type: contentType });
    saveAs(blob, filename);
  }

  convertirYDescargar(data: any) {
    // base64 To ArrayBuffer
    const binaryString = atob(data.content);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    this.download(bytes, this.codFlow + '.json', data.contentType);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/dynamicFlow/productFlowConfig.component.ts